import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { useCommandHandler } from "../hooks";
import { Command } from "../hooks/Command";

export const treeNodeValue = Symbol();

export type TreeNode<T> = {
    inner?: { [key: string]: TreeNode<T> | undefined };
    value?: T;
};

export type TreeStructure<T = unknown> = TreeNode<T>;

export function TreeExplorer<T>(props: {
    class?: string,
    onChange: (data: TreeNode<T> | null) => void,
    treeData?: TreeStructure<T> | null,
    doSelectByPath?: Command<[path: string]>,
    rootName: string
}) {
    const [treeData, setTreeData] = useState(props.treeData);
    const [currentPath, setCurrentPath] = useState([] as readonly string[]);
    const [selectedItem, setSelectedItem] = useState(null as string | null);

    useEffect(() => {
        setTreeData(props.treeData);
    }, [props.treeData])

    useCommandHandler(props.doSelectByPath, (path) => {
        const split = path.split("/");
        let data: TreeNode<T> | null | undefined = treeData;

        if (!data) {
            return;
        }

        for (let i = 0; i < split.length; i++) {
            const part = split[i];

            if (!data.inner) {
                return;
            }

            data = data.inner[part];

            if (!data) {
                return;
            }
        }

        setCurrentPath(split.slice(0, split.length - 1));
        setSelectedItem(split[split.length - 1]);
        props.onChange(data);
    });

    let currentTreeData: TreeNode<T> | null | undefined = treeData;

    if (currentTreeData) {
        for (let i = 0; i < currentPath.length; i++) {
            if (currentTreeData?.inner) {
                currentTreeData = currentTreeData.inner[currentPath[i]];
            }
        }
    }

    return <div class={"tree-explorer" + (props.class ? " " + props.class : "")}>
        <div class="explorer">
            <div class="menu">
                <div class="back" onClick={() => {
                    if (currentPath.length <= 0) {
                        return;
                    }

                    setCurrentPath((prev) => prev.slice(0, prev.length - 1))
                    setSelectedItem(null);
                    props.onChange(null);
                }}>
                    <button type="button" class="icon flat borderless r26">arrow_upward</button>
                </div>
                <div class="path">
                    <span class="path-link" onClick={() => {
                        setCurrentPath([]);
                        setSelectedItem(null);
                        props.onChange(null);
                    }}>{props.rootName}</span>
                    {currentPath.map((p, i) => [
                        <span class="icon">chevron_right</span>,
                        <span class="path-link" onClick={() => {
                            setCurrentPath(currentPath.slice(0, i + 1));
                            setSelectedItem(null);
                            props.onChange(null);
                        }}>{p}</span>
                    ])}
                </div>
            </div>
            <div class="list success">
                {currentTreeData?.inner ? Object.entries(currentTreeData.inner).map(([key, value]) => {
                    if (key.startsWith("/"))  {
                        return;
                    }

                    if (!value) {
                        return;
                    }

                    return <LabelTemplatesExplorerEntry
                        class={"item" + (selectedItem === key ? " selected" : "") + (value.inner ? " directory" : " file")}
                        title={key} data={value} onClick={(data) => {
                        if (value.inner) {
                            setCurrentPath((prev) => prev.concat([key]));
                        }
                        else {
                            setSelectedItem(key);
                            props.onChange(data);
                        }
                    }}/>;
                }) : null}
            </div>
        </div>
    </div>;
}

function LabelTemplatesExplorerEntry<T>(props: { class: string, title: string, data: TreeNode<T>, onClick: (data: TreeNode<T>) => void }) {
    // console.log(props.data);
    return <div class={props.class} onClick={() => props.onClick(props.data)}>
        <div>{props.title}</div>
        <div style="margin-left: 10px">
        </div>
    </div>;
}
